<app-case-practice-ts-list></app-case-practice-ts-list>



// WEBPACK FOOTER //
// ./src/app/case-practice-ts/case-practice-ts.component.html